import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { ZxcvbnService } from 'src/app/services/zxcvbn/zxcvbn.service';

@Directive({
  selector: '[passwordStrength]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PasswordStrengthDirective, multi: true }]
})
export class PasswordStrengthDirective implements Validator {
  constructor(
    private zxcvbnService: ZxcvbnService
  ) {}

  validate(control: AbstractControl): ValidationErrors | null {
    const value: string = control.value ?? '';
    const errors: ValidationErrors = {};

    if (value.length < 12) errors['minLength'] = true;
    if (!/[A-Z]/.test(value)) errors['hasUppercase'] = true;
    if (!/[a-z]/.test(value)) errors['hasLowercase'] = true;
    if (!/[0-9]/.test(value)) errors['hasNumber'] = true;
    if (!/(\W|_)/.test(value)) errors['hasSpecial'] = true;

    return Object.keys(errors).length ? errors : null;
  }
}
